import React from 'react';
import type { TeamMember } from '../../../../types';
import { getUserDisplayName } from '../../../../utils/userUtils';

interface TeamMemberFilterProps {
  teamMembers: TeamMember[];
  selectedMemberId: string | null;
  onMemberSelect: (memberId: string | null) => void;
  isVisible: boolean;
}

export const TeamMemberFilter: React.FC<TeamMemberFilterProps> = ({
  teamMembers,
  selectedMemberId,
  onMemberSelect,
  isVisible
}) => {
  if (!isVisible) return null;

  return (
    <div className="team-member-filter-sidebar">
      {/* 全部选项 */}
      <div
        className={`team-member-tab ${selectedMemberId === null ? 'active' : ''}`}
        onClick={() => onMemberSelect(null)}
      >
        <div className="tab-text">全部</div>
        <div className="tab-icon">All</div>
      </div>

      {/* 各个团队成员标签 */}
      {teamMembers.map(member => {
        const displayName = getUserDisplayName(member.user);
        return (
          <div
            key={member.id}
            className={`team-member-tab ${selectedMemberId === member.userId ? 'active' : ''}`}
            onClick={() => onMemberSelect(member.userId)}
          >
            <div className="tab-text">
              {displayName}
            </div>
            {/* 成员头像或图标 */}
            <div className="tab-icon">
              {displayName.charAt(0).toUpperCase()}
            </div>
          </div>
        );
      })}
    </div>
  );
};